'use client';

import { useStudioSeriesDetail } from '@/api/queries/studio-series.queries';
import { CourseStatusPill } from '@/app/studio/courses/_components/CourseStatusPill';
import { toSeriesStatus } from '@/app/studio/series/_components/series-status';
import { PlaySquare, Settings } from 'lucide-react';
import { ContextualSidebarShell } from './ContextualSidebarShell';
import type { ContextualNavItem, ContextualSidebarComponentProps } from './types';

/**
 * Series-scoped sidebar. Mounted when pathname matches
 * `/studio/series/<uuid>/`. Shares the detail query cache with
 * `SeriesDetailShell` — no extra request.
 */
export function SeriesSidebarContent({ paramValue: uuid }: ContextualSidebarComponentProps) {
  const { data: series } = useStudioSeriesDetail(uuid);

  const navItems: ContextualNavItem[] = [
    {
      id: 'details',
      label: 'Details',
      href: `/studio/series/${uuid}/details`,
      icon: Settings,
    },
    {
      id: 'videos',
      label: 'Episodes',
      href: `/studio/series/${uuid}/videos`,
      icon: PlaySquare,
    },
  ];

  const episodeNoun = series?.videos_count === 1 ? 'episode' : 'episodes';
  const episodesLabel = series === undefined ? null : `${series.videos_count} ${episodeNoun}`;

  return (
    <ContextualSidebarShell
      backHref="/studio/series"
      backLabel="Channel content"
      entity={{
        thumbnail: series?.thumbnail,
        title: series?.title,
        eyebrow: 'Your series',
        statusPill: series ? <CourseStatusPill status={toSeriesStatus(series.status)} /> : null,
        metaLine: episodesLabel,
      }}
      navItems={navItems}
    />
  );
}
